<div class="modal-content">
  <!-- STANDARD Modal Header (V7) -->
  <div class="modal-header">
    <div class="header-content">
      <h3 class="modal-title">{{modalTitle}}</h3>
      <div class="header-icons">
        <i class="fa minimize-icon" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
          (click)="minimise = !minimise"></i>
        <i class="fa fa-times close-icon" (click)="cancel()"></i>
      </div>
    </div>
  </div>

  <!-- Loading state while checking if Schedule O is enabled -->
  @if (showF5471ScheduleO === null) {
<div class="modal-body" [hidden]="minimise">
    <div class="formLoader">
      <i class="fa fa-spinner fa-spin gt-refresh"></i>
      <p>Checking Schedule O availability...</p>
    </div>
  </div>
}

  <!-- Show enabled message if Schedule O is not enabled -->
  @if (showF5471ScheduleO === false) {
<div style="padding: 15px; text-align: left; border-top: 1px solid #e5e5e5;"
    [hidden]="minimise">
    {{ body }}
  </div>
}

  @if (showF5471ScheduleO === true) {
<div class="modal-body" [hidden]="minimise">

    <!-- Loading indicator while any API calls are pending -->
    @if (showFormLoader || !isDataFullyLoaded) {
<div class="formLoader" align="center">
      <i class="fa fa-spinner fa-spin gt-refresh" style="color: #e12827; font-size: 36px;"></i>
    </div>
}

    <!-- Only show content when all data is fully loaded -->
    @if (!showFormLoader && isDataFullyLoaded) {
<div>
      <!-- Tab Navigation -->
      <ul class="nav nav-pills" role="tablist">
        @for (tab of tabs; track $index) {
<li [class.active]="tab.id === activeTab">
          <a (click)="activeTab = tab.id; onTabChange(tab.name)" style="cursor: pointer;"
            class="btn-sm">
            {{ tab.name }}
          </a>
        </li>
}
      </ul>

      <div class="tab-content">

        <!-- Section 5471 (Tab 0) -->
        @if (activeTab === 0) {
<div class="tab-pane active" style="max-height: calc(90vh - 200px);">
          <div>
            <h3 class="col-md-12 text-center">
              <b>5471 Schedule O: Organization or Reorganization of Foreign Corporation, and Acquisitions and
                Dispositions of its Stock</b>
            </h3>

            <!-- Content is always shown here since loading is handled at modal level -->
            <div>
              <div class="form-group">
                <label class="col-md-9 control-label">
                  <strong>List the date of any reorganization of the foreign corporation that occurred during the last 4
                    years while any
                    U.S. person held 10% or more in value or vote (directly or indirectly) of the corporation's
                    stock:</strong>
                </label>
                <div class="col-md-2">
                  <input type="date" class="form-control" [value]="tab5471Data[0]?.VALUE"
                    (input)="onTab5471InputChange(0, $event)" 
                    [class.is-invalid]="hasValidationError('main5471_date')" required>
                  @if (hasValidationError('main5471_date')) {
<div class="invalid-feedback">
                    {{ getValidationError('main5471_date') }}
                  </div>
}
                </div>
              </div>

              <div class="form-group">
                <span class="col-md-10">
                  <input type="checkbox" class="mr-3" [checked]="tab5471Data[1]?.VALUE === 'Y'"
                    (change)="onTab5471CheckboxChange(1, $event)">
                  <label><strong>Check here, if any of the following 351/367, 332/367 or 368/367 statements
                      apply.</strong></label>
                </span>
              </div>

              <div class="form-group">
                <span class="col-md-10">
                  <label><strong>Notes (not included on Schedule O):</strong></label>
                  <textarea required name="message" placeholder="add message" style="height:120px; width: 100%;"
                    class="form-control input-sm" [value]="tab5471Data[2]?.VALUE"
                    (input)="onTab5471InputChange(2, $event)"
                    [class.is-invalid]="hasValidationError('main5471_textarea')"></textarea>
                  @if (hasValidationError('main5471_textarea')) {
<div class="invalid-feedback">
                    {{ getValidationError('main5471_textarea') }}
                  </div>
}
                </span>
              </div>

              <div class="sections-container">
                
                <!-- Section A - General Shareholder Information -->
                @if (sectionAData.length > 0) {
<div class="col-md-12">
                  <div class="text-center section-header" style="background-color: #cd5763; font-size: 18px; margin-top: 10px; cursor: pointer;" (click)="collapsed5 = !collapsed5">
                    <span style="color:#fff;">
                      Section A - General Shareholder Information
                    </span>
                  </div>
                  @if (collapsed5) {
<div class="section-table-scroll">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th rowspan="2">Date (if any) shareholder last filed information return under section 6046 for the foreign corporation</th>
                          <th rowspan="2">Action</th>
                          <th rowspan="2">Entered by</th>
                          <th rowspan="2">Entered on</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of sectionAData; track $index) {
<tr>
                          <td>{{ item[0]?.VALUE }}</td>
                          <td>
                            <div style="display: flex; flex-wrap: nowrap; align-items: center; border: none;">
                            <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;margin-right: 7px;" 
                                    (click)="editSchedule(item, 'A')">Edit</button>
                            <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;" 
                                    (click)="deleteSchedule(item, 'A')" [disabled]="deletingItem === item">
                              @if (deletingItem === item) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
}Delete
                            </button>
                          </div>
                          </td>
                          <td>{{ item[0]?.updated_by }}</td>
                          <td>{{ item[0]?.updated_on }}</td>
                        </tr>
}
                      </tbody>
                    </table>
                  </div>
}
                </div>
}

                <!-- Section B - U.S. Persons Who Are Officers or Directors -->
                @if (sectionBData.length > 0) {
<div class="col-md-12">
                  <div class="text-center section-header" style="background-color: #cd5763; font-size: 18px; cursor: pointer;" (click)="collapsed4 = !collapsed4">
                    <span style="color:#fff;">
                      Section B - U.S. Persons Who Are Officers or Directors of the Foreign Corporation
                    </span>
                  </div>
                  @if (collapsed4) {
<div class="section-table-scroll">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th rowspan="2">Name of U.S. officer or director</th>
                          <th rowspan="2">Address</th>
                          <th rowspan="2">Social security number</th>
                          <th colspan="2">Check appropriate box(es)</th>
                          <th rowspan="2">Action</th>
                          <th rowspan="2">Entered by</th>
                          <th rowspan="2">Entered on</th>
                        </tr>
                        <tr>
                          <th>Officer</th>
                          <th>Director</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of sectionBData; track $index) {
<tr>
                          <td>{{ item[0]?.VALUE }} {{ item[1]?.VALUE }}</td>
                          <td>
                            {{ item[3]?.VALUE }}, <br>
                            {{ item[4]?.VALUE ? item[4]?.VALUE + ',' : item[4]?.VALUE }} {{ item[5]?.VALUE ? item[5]?.VALUE + ',' : item[5]?.VALUE }} 
                            {{ item[6]?.VALUE?.code ? item[6]?.VALUE?.code + ',' : (item[6]?.VALUE ? item[6]?.VALUE + ',' : item[6]?.VALUE) }} {{ item[7]?.VALUE ? item[2]?.VALUE?.COUNTRY_CODE + ',' : item[2]?.VALUE?.COUNTRY_CODE }} {{ item[7]?.VALUE }}
                          </td>
                          <td>{{ item[8]?.VALUE }}</td>
                          <td>{{ item[9]?.VALUE === '1' ? 'Y' : '' }}</td>
                          <td>{{ item[10]?.VALUE === '1' ? 'Y' : '' }}</td>
                          <td>
                            <div style="display: flex; flex-wrap: nowrap; align-items: center; border: none;">  
                              <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;margin-right: 7px;" 
                                      (click)="editSchedule(item, 'B')">Edit</button>
                              <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;" 
                                      (click)="deleteSchedule(item, 'B')" [disabled]="deletingItem === item">
                                @if (deletingItem === item) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
}Delete
                              </button>
                            </div>
                          </td>
                          <td>{{ item[9]?.updated_by }}</td>
                          <td>{{ item[9]?.updated_on }}</td>
                        </tr>
}
                      </tbody>
                    </table>
                  </div>
}
                </div>
}

                <!-- Section C - Acquisition of stock -->
                @if (sectionCData.length > 0) {
<div class="col-md-12">
                  <div class="text-center section-header" style="background-color: #cd5763; font-size: 18px; cursor: pointer;" (click)="collapsed1 = !collapsed1">
                    <span style="color:#fff;">
                      Section C - Acquisition of stock
                    </span>
                  </div>
                  @if (collapsed1) {
<div class="section-table-scroll">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th rowspan="2">Name of shareholder(s) filing this schedule</th>
                          <th rowspan="2">Class of Stock acquired</th>
                          <th rowspan="2">Date of acquisition</th>
                          <th rowspan="2">Method of acquisition</th>
                          <th colspan="3">Number of shares acquired of</th>
                          <th rowspan="2">Action</th>
                          <th rowspan="2">Amount paid <br>or value given(in USD)</th>
                          <th rowspan="2">Name and address of person from whom shares were acquired</th>
                          <th rowspan="2">Entered by</th>
                          <th rowspan="2">Entered on</th>
                        </tr>
                        <tr>
                          <th>Directly</th>
                          <th>Indirectly</th>
                          <th>Constructively</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of sectionCData; track $index) {
<tr>
                          <td>{{ item[0]?.VALUE?.LEGAL_ENTITY_NAME }}</td>
                          <td>{{ item[1]?.VALUE }}</td>
                          <td>{{ item[2]?.VALUE | date:'MM/dd/yyyy' }}</td>
                          <td>{{ item[3]?.VALUE }}</td>
                          <td align="right">{{ item[4]?.VALUE | number }}</td>
                          <td align="right">{{ item[5]?.VALUE | number }}</td>
                          <td align="right">{{ item[6]?.VALUE | number }}</td>
                          <td>
                            <div style="display: flex; flex-wrap: nowrap; align-items: center; border: none;">
                            <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;margin-right: 7px;" 
                                    (click)="editSchedule(item, 'C')">Edit</button>
                            <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;" 
                                    (click)="deleteSchedule(item, 'C')" [disabled]="deletingItem === item">
                              @if (deletingItem === item) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
}Delete
                            </button>
                          </div>
                          </td>
                          <td align="right">{{ item[7]?.VALUE | number }}</td>
                          <td>
                            {{ item[9]?.VALUE }} {{ item[10]?.VALUE }}<br>
                            {{ item[12]?.VALUE }}, <br>
                            {{ item[13]?.VALUE ? item[13]?.VALUE + ',' : item[13]?.VALUE }} {{ item[14]?.VALUE ? item[14]?.VALUE + ',' : item[14]?.VALUE }}
                            {{ item[15]?.VALUE?.code ? item[15]?.VALUE?.code + ',' : (item[15]?.VALUE ? item[15]?.VALUE + ',' : item[15]?.VALUE) }} {{ item[16]?.VALUE ? item[11]?.VALUE?.COUNTRY_CODE + ',' : item[11]?.VALUE?.COUNTRY_CODE }} {{ item[16]?.VALUE }}
                          </td>
                          <td>{{ item[9]?.updated_by }}</td>
                          <td>{{ item[9]?.updated_on }}</td>
                        </tr>
}
                      </tbody>
                    </table>
                  </div>
}
                </div>
}

                <!-- Section D - Disposition of stock -->
                @if (sectionDData.length > 0) {
<div class="col-md-12">
                  <div class="text-center section-header" style="background-color: #cd5763; font-size: 18px; cursor: pointer;" (click)="collapsed2 = !collapsed2">
                    <span style="color:#fff;">
                      Section D - Disposition of stock
                    </span>
                  </div>
                  @if (collapsed2) {
<div class="section-table-scroll">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th rowspan="2">Name of shareholder disposing of stock</th>
                          <th rowspan="2">Class of Stock</th>
                          <th rowspan="2">Date of disposition</th>
                          <th rowspan="2">Method of disposition</th>
                          <th colspan="3">Number of shares disposed of</th>
                          <th rowspan="2">Action</th>
                          <th rowspan="2">Amount paid (in USD)</th>
                          <th rowspan="2">Name and address of person from whom shares were disposed:</th>
                          <th rowspan="2">Entered by</th>
                          <th rowspan="2">Entered on</th>
                        </tr>
                        <tr>
                          <th>Directly</th>
                          <th>Indirectly</th>
                          <th>Constructively</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of sectionDData; track $index) {
<tr>
                          <td>{{ item[0]?.VALUE?.LEGAL_ENTITY_NAME }}</td>
                          <td>{{ item[1]?.VALUE }}</td>
                          <td>{{ item[2]?.VALUE | date:'MM/dd/yyyy' }}</td>
                          <td>{{ item[3]?.VALUE }}</td>
                          <td align="right">{{ item[4]?.VALUE | number }}</td>
                          <td align="right">{{ item[5]?.VALUE | number }}</td>
                          <td align="right">{{ item[6]?.VALUE | number }}</td>
                          <td>
                            <div style="display: flex; flex-wrap: nowrap; align-items: center; border: none;">
                              <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;margin-right: 7px;" 
                                      (click)="editSchedule(item, 'D')">Edit</button>
                              <button class="btn btn-info btn-sm" type="button" style="background-color: #cd5763;" 
                                      (click)="deleteSchedule(item, 'D')" [disabled]="deletingItem === item">
                                @if (deletingItem === item) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
}Delete
                              </button>
                            </div>
                          </td>
                          <td align="right">{{ item[7]?.VALUE | number }}</td>
                          <td>
                            {{ item[9]?.VALUE }} {{ item[10]?.VALUE }}<br>
                            {{ item[12]?.VALUE }}, <br>
                            {{ item[13]?.VALUE ? item[13]?.VALUE + ',' : item[13]?.VALUE }} {{ item[14]?.VALUE ? item[14]?.VALUE + ',' : item[14]?.VALUE }}
                            {{ item[15]?.VALUE?.code ? item[15]?.VALUE?.code + ',' : (item[15]?.VALUE ? item[15]?.VALUE + ',' : item[15]?.VALUE) }} {{ item[16]?.VALUE ? item[11]?.VALUE?.COUNTRY_CODE + ',' : item[11]?.VALUE?.COUNTRY_CODE }} {{ item[16]?.VALUE }}
                          </td>
                          <td>{{ item[9]?.updated_by }}</td>
                          <td>{{ item[9]?.updated_on }}</td>
                        </tr>
}
                      </tbody>
                    </table>
                  </div>
}
                </div>
}

                <!-- Section E - Organization or Reorganization of Foreign Corporation -->
                @if (sectionEData.length > 0) {
<div class="col-md-12">
                  <div class="text-center section-header" style="background-color: #cd5763; color: #fff; font-size: 18px; cursor: pointer;" (click)="collapsed3 = !collapsed3">
                    <span style="color:#fff;">
                      Section E - Organization or Reorganization of Foreign Corporation
                    </span>
                  </div>
                  @if (collapsed3) {
<div class="section-table-scroll">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th rowspan="3">Name and address of transferor</th>
                          <th rowspan="2">Identifying number (if any)</th>
                          <th rowspan="2">Date of transfer</th>
                          <th rowspan="2">Action</th>
                          <th colspan="3">Assets transferred to foreign corporation</th>
                          <th rowspan="2">Description of assets transferred by,<br>or notes or securities issued by, <br>foreign corporation</th>
                          <th rowspan="2">Entered by</th>
                          <th rowspan="2">Entered on</th>
                        </tr>
                        <tr>
                          <th>Description of assets</th>
                          <th>Fair market value</th>
                          <th>Adjusted basis</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (item of sectionEData; track $index) {
<tr>
                          <td>
                            {{ item[2]?.VALUE }} {{ item[3]?.VALUE }}<br>
                            {{ item[5]?.VALUE }}, <br>
                            {{ item[6]?.VALUE ? item[6]?.VALUE + ',' : item[6]?.VALUE }} {{ item[7]?.VALUE ? item[7]?.VALUE + ',' : item[7]?.VALUE }}
                            {{ item[8]?.VALUE?.code ? item[8]?.VALUE?.code + ',' : (item[8]?.VALUE ? item[8]?.VALUE + ',' : item[8]?.VALUE) }} {{ item[9]?.VALUE ? item[4]?.VALUE?.COUNTRY_CODE + ',' : item[4]?.VALUE?.COUNTRY_CODE }} {{ item[9]?.VALUE }}
                          </td>
                          <td>{{ item[10]?.VALUE }} {{ item[16]?.VALUE }}</td>
                          <td>{{ item[11]?.VALUE | date:'MM/dd/yyyy' }}</td>
                          <td>
                            <div style="display: flex; flex-wrap: nowrap; align-items: center; border: none;">                             
                              <button class="btn btn-info btn-sm" style="background-color: #cd5763;margin-right: 7px;" type="button" 
                                      (click)="editSchedule(item, 'E')">Edit</button>
                              <button class="btn btn-info btn-sm" style="background-color: #cd5763;" type="button" 
                                      (click)="deleteSchedule(item, 'E')" [disabled]="deletingItem === item">
                                @if (deletingItem === item) {
<span><i class="fa fa-spinner fa-pulse"></i> </span>
}Delete
                              </button>
                            </div>
                          </td>
                          <td>{{ item[12]?.VALUE }}</td>
                          <td align="right">{{ item[13]?.VALUE | number }}</td>
                          <td align="right">{{ item[14]?.VALUE | number }}</td>
                          <td>{{ item[15]?.VALUE }}</td>
                          <td>{{ item[2]?.updated_by }}</td>
                          <td>{{ item[2]?.updated_on }}</td>
                        </tr>
}
                      </tbody>
                    </table>
                  </div>
}
                </div>
}

              </div>
            </div>
          </div>
        </div>
}

        <!-- Section A (Tab 5) -->
        @if (activeTab === 5) {
<div class="tab-pane active" style="max-height: calc(90vh - 200px);">
          <div>
            <div class="text-center">
              <h3><b>Form 5471 Schedule O: Section A - General Shareholder Information</b></h3>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>Date (if any) shareholder last filed information return under section 6046 for the foreign corporation:</strong></label>
              <div class="col-md-6">
                <input type="date" class="form-control"
                       [value]="selectedTabAData[0]?.VALUE"
                       (input)="onSectionAInputChange(0, $event)"
                       [class.is-invalid]="hasValidationError('sectionA_date')" required>
                @if (hasValidationError('sectionA_date')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionA_date') }}
                </div>
}
              </div>
            </div>
          </div>
        </div>
}

        <!-- Section B (Tab 4) -->
        @if (activeTab === 4) {
<div class="tab-pane active" style="max-height: calc(90vh - 200px);">
          <div>
            <div class="text-center">
              <h3><b>Form 5471 Schedule O: Section B - U.S. Persons Who Are Officers or Directors of the Foreign
                  Corporation</b></h3>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>First Name:</strong></label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" required [value]="selectedTabBData[0]?.VALUE"
                  (input)="onSectionBInputChange(0, $event)"
                  [class.is-invalid]="hasValidationError('sectionB_firstName')">
                @if (hasValidationError('sectionB_firstName')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionB_firstName') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>Last Name:</strong></label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" [value]="selectedTabBData[1]?.VALUE"
                  (input)="onSectionBInputChange(1, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>Country:</strong></label>
              <div class="col-md-6">
                <select class="form-control" required 
                  [value]="selectedTabBData[2]?.VALUE?.COUNTRY_CODE"
                  (change)="onSectionBCountryChange($event)"
                  [class.is-invalid]="hasValidationError('sectionB_country')">
                  <option value="">Select Country</option>
                  @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE"
                    [selected]="selectedTabBData[2]?.VALUE?.COUNTRY_CODE === country.COUNTRY_CODE">
                    {{country.COUNTRY_CODE}} - {{country.COUNTRY_NAME}}
                  </option>
}
                </select>
                @if (hasValidationError('sectionB_country')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionB_country') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>Address Line 1:</strong></label>
              <div class="col-md-6">
                <input type="text" maxlength="35" class="form-control" required [value]="selectedTabBData[3]?.VALUE"
                  (input)="onSectionBInputChange(3, $event)"
                  [class.is-invalid]="hasValidationError('sectionB_address1')">
                @if (hasValidationError('sectionB_address1')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionB_address1') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>Address Line 2:</strong></label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" [value]="selectedTabBData[4]?.VALUE"
                  (input)="onSectionBInputChange(4, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>City:</strong></label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" required [value]="selectedTabBData[5]?.VALUE"
                  (input)="onSectionBInputChange(5, $event)"
                  [class.is-invalid]="hasValidationError('sectionB_city')">
                @if (hasValidationError('sectionB_city')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionB_city') }}
                </div>
}
              </div>
            </div>

            @if (selectedTabBData[2]?.VALUE?.COUNTRY_CODE) {
<div class="row form-group">
              <label class="col-md-6"><strong>State:</strong></label>
              <div class="col-md-6">
                @if (selectedTabBData[2]?.VALUE?.COUNTRY_CODE === 'US') {
<select class="form-control"
                  [value]="selectedTabBData[6]?.VALUE?.code || selectedTabBData[6]?.VALUE" (change)="onSectionBInputChange(6, $event)" required
                  [class.is-invalid]="hasValidationError('sectionB_state')">
                  <option value="">Select State</option>
                  @for (state of states; track $index) {
<option [value]="state.code"
                    [selected]="(selectedTabBData[6]?.VALUE?.code || selectedTabBData[6]?.VALUE) === state.code">
                    {{state.code}} - {{state.name}}
                  </option>
}
                </select>
}
                @if (selectedTabBData[2]?.VALUE?.COUNTRY_CODE !== 'US') {
<input type="text" maxlength="75" class="form-control"
                  
                  [value]="selectedTabBData[6]?.VALUE"
                  (input)="onSectionBInputChange(6, $event)"
                  [class.is-invalid]="hasValidationError('sectionB_state')">
}
                @if (hasValidationError('sectionB_state')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionB_state') }}
                </div>
}
              </div>
            </div>
}

            <div class="row form-group">
              <label class="col-md-6"><strong>Zip/Postal Code:</strong></label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" [value]="selectedTabBData[7]?.VALUE"
                  (input)="onSectionBInputChange(7, $event)"
                  [class.is-invalid]="hasValidationError('sectionB_zip')">
                @if (hasValidationError('sectionB_zip')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionB_zip') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>Social Security Number:</strong></label>
              <div class="col-md-6">
                <input type="text" maxlength="9" class="form-control" placeholder="9 digits"
                  [value]="selectedTabBData[8]?.VALUE" (input)="onSectionBInputChange(8, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6"><strong>Check appropriate box(es):</strong></label>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <input type="checkbox" class="mr-3" [checked]="selectedTabBData[9]?.VALUE === '1'"
                      (change)="onSectionBCheckboxChange(9, $event)">
                    <strong>Officer</strong>
                  </div>
                  <div class="col-md-6">
                    <input type="checkbox" class="mr-3" [checked]="selectedTabBData[10]?.VALUE === '1'"
                      (change)="onSectionBCheckboxChange(10, $event)">
                    <strong>Director</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
}

        <!-- Section C - Stock Acquisition (Tab 1) -->
        @if (activeTab === 1) {
<div class="tab-pane active" style="max-height: calc(90vh - 200px);">
          <div>
            <div class="text-center">
              <h3><b>Form 5471 Schedule O: Section C - Acquisition of stock</b></h3>
            </div>
            <div class="text-left">
              <h4><i class="fa fa-info-circle"></i> All amounts in U. S. Dollars</h4>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name of shareholder(s) filing this schedule:</label>
              <div class="col-md-6">
                <select class="form-control" [value]="selectedTabCData[0]?.VALUE?.LEID || ''"
                  (change)="onSectionCInputChange(0, $event)" required
                  [class.is-invalid]="hasValidationError('sectionC_shareholder')">
                  <option value="">Select</option>
                  @for (item of filingGroup; track $index) {
<option [value]="item.LEID"
                    [selected]="selectedTabCData[0]?.VALUE?.LEID === item.LEID">
                    {{item.LEID}} - {{item.LEGAL_ENTITY_NAME}}
                  </option>
}
                </select>
                @if (hasValidationError('sectionC_shareholder')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_shareholder') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Class of stock acquired:</label>
              <div class="col-md-6">
                <input type="text" maxlength="20" class="form-control" [value]="selectedTabCData[1]?.VALUE"
                  (input)="onSectionCInputChange(1, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Date of Acquisition:</label>
              <div class="col-md-6">
                <input type="date" class="form-control" [value]="selectedTabCData[2]?.VALUE"
                  (input)="onSectionCInputChange(2, $event)" required
                  [class.is-invalid]="hasValidationError('sectionC_date')">
                @if (hasValidationError('sectionC_date')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_date') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Method of acquisition:</label>
              <div class="col-md-6">
                <input type="text" maxlength="20" class="form-control" [value]="selectedTabCData[3]?.VALUE"
                  (input)="onSectionCInputChange(3, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Number of shares acquired:</label>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Directly:</label>
              <div class="col-md-6">
                <input type="number" class="form-control text-right" [value]="selectedTabCData[4]?.VALUE"
                  (input)="onSectionCInputChange(4, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Indirectly:</label>
              <div class="col-md-6">
                <input type="number" class="form-control text-right" [value]="selectedTabCData[5]?.VALUE"
                  (input)="onSectionCInputChange(5, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Constructively:</label>
              <div class="col-md-6">
                <input type="number" class="form-control text-right" [value]="selectedTabCData[6]?.VALUE"
                  (input)="onSectionCInputChange(6, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Amount paid or value given (in U.S. Dollars):</label>
              <div class="col-md-6">
                <input type="number" step="0.01" class="form-control text-right" [value]="selectedTabCData[7]?.VALUE"
                  (input)="onSectionCInputChange(7, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name and address of person from whom shares were acquired:</label>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-4">
                    <label>
                      <input type="radio" name="personOrBusiness_C" value="P"
                        [checked]="selectedTabCData[8]?.VALUE === 'P'" (change)="onSectionCInputChange(8, $event)">
                      Person
                    </label>
                  </div>
                  <div class="col-md-4">
                    <label>
                      <input type="radio" name="personOrBusiness_C" value="B"
                        [checked]="selectedTabCData[8]?.VALUE === 'B'" (change)="onSectionCInputChange(8, $event)">
                      Business
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name Line 1:</label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" required [value]="selectedTabCData[9]?.VALUE"
                  (input)="onSectionCInputChange(9, $event)"
                  [class.is-invalid]="hasValidationError('sectionC_name')">
                @if (hasValidationError('sectionC_name')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_name') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name Line 2 (allowed only if name/address type is Business):</label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" [disabled]="selectedTabCData[8]?.VALUE === 'P'"
                  [value]="selectedTabCData[10]?.VALUE" (input)="onSectionCInputChange(10, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Country:</label>
              <div class="col-md-6">
                <select class="form-control" required [value]="selectedTabCData[11]?.VALUE?.COUNTRY_CODE"
                  (change)="onSectionCCountryChange($event)"
                  [class.is-invalid]="hasValidationError('sectionC_country')">
                  <option value="">Select Country</option>
                  @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE"
                    [selected]="selectedTabCData[11]?.VALUE?.COUNTRY_CODE === country.COUNTRY_CODE">
                    {{country.COUNTRY_CODE}} - {{country.COUNTRY_NAME}}
                  </option>
}
                </select>
                @if (hasValidationError('sectionC_country')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_country') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Address Line 1:</label>
              <div class="col-md-6">
                <input type="text" maxlength="35" class="form-control" required [value]="selectedTabCData[12]?.VALUE"
                  (input)="onSectionCInputChange(12, $event)"
                  [class.is-invalid]="hasValidationError('sectionC_address1')">
                @if (hasValidationError('sectionC_address1')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_address1') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Address Line 2:</label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" [value]="selectedTabCData[13]?.VALUE"
                  (input)="onSectionCInputChange(13, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">City:</label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" required [value]="selectedTabCData[14]?.VALUE"
                  (input)="onSectionCInputChange(14, $event)"
                  [class.is-invalid]="hasValidationError('sectionC_city')">
                @if (hasValidationError('sectionC_city')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_city') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">State:</label>
              <div class="col-md-6">
                @if (selectedTabCData[11]?.VALUE?.COUNTRY_CODE === 'US') {
<select class="form-control"
                  [value]="selectedTabCData[15]?.VALUE?.code || selectedTabCData[15]?.VALUE" (change)="onSectionCInputChange(15, $event)" required
                  [class.is-invalid]="hasValidationError('sectionC_state')">
                  <option value="">Select State</option>
                  @for (state of states; track $index) {
<option [value]="state.code"
                    [selected]="(selectedTabCData[15]?.VALUE?.code || selectedTabCData[15]?.VALUE) === state.code">
                    {{state.code}} - {{state.name}}
                  </option>
}
                </select>
}
                @if (selectedTabCData[11]?.VALUE?.COUNTRY_CODE !== 'US') {
<input type="text" maxlength="75" class="form-control"
                  [value]="selectedTabCData[15]?.VALUE"
                  (input)="onSectionCInputChange(15, $event)">
}
                @if (hasValidationError('sectionC_state')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_state') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Zip/Postal Code:</label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" required [value]="selectedTabCData[16]?.VALUE"
                  (input)="onSectionCInputChange(16, $event)"
                  [class.is-invalid]="hasValidationError('sectionC_zip')">
                @if (hasValidationError('sectionC_zip')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionC_zip') }}
                </div>
}
              </div>
            </div>

          </div>
        </div>
}

        <!-- Section D - Stock Disposition (Tab 2) -->
        @if (activeTab === 2) {
<div class="tab-pane active" style="max-height: calc(90vh - 200px);">
          <div>
            <div class="text-center">
              <h3><b>Form 5471 Schedule O: Section D - Disposition of stock</b></h3>
            </div>
            <div class="text-left">
              <h4><i class="fa fa-info-circle"></i> All amounts in U. S. Dollars</h4>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name of shareholder disposing of stock:</label>
              <div class="col-md-6">
                <select class="form-control" [value]="selectedTabDData[0]?.VALUE?.LEID || ''"
                  (change)="onSectionDInputChange(0, $event)" required
                  [class.is-invalid]="hasValidationError('sectionD_shareholder')">
                  <option value="">Select</option>
                  @for (item of filingGroup; track $index) {
<option [value]="item.LEID"
                    [selected]="selectedTabDData[0]?.VALUE?.LEID === item.LEID">
                    {{item.LEID}} - {{item.LEGAL_ENTITY_NAME}}
                  </option>
}
                </select>
                @if (hasValidationError('sectionD_shareholder')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_shareholder') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Class of stock:</label>
              <div class="col-md-6">
                <input type="text" maxlength="20" class="form-control" [value]="selectedTabDData[1]?.VALUE"
                  (input)="onSectionDInputChange(1, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Date of Disposition:</label>
              <div class="col-md-6">
                <input type="date" class="form-control" [value]="selectedTabDData[2]?.VALUE"
                  (input)="onSectionDInputChange(2, $event)" required
                  [class.is-invalid]="hasValidationError('sectionD_date')">
                @if (hasValidationError('sectionD_date')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_date') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Method of disposition:</label>
              <div class="col-md-6">
                <input type="text" maxlength="20" class="form-control" [value]="selectedTabDData[3]?.VALUE"
                  (input)="onSectionDInputChange(3, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Number of shares disposed of:</label>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Directly:</label>
              <div class="col-md-6">
                <input type="number" class="form-control text-right" [value]="selectedTabDData[4]?.VALUE"
                  (input)="onSectionDInputChange(4, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Indirectly:</label>
              <div class="col-md-6">
                <input type="number" class="form-control text-right" [value]="selectedTabDData[5]?.VALUE"
                  (input)="onSectionDInputChange(5, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Constructively:</label>
              <div class="col-md-6">
                <input type="number" class="form-control text-right" [value]="selectedTabDData[6]?.VALUE"
                  (input)="onSectionDInputChange(6, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Amount received (in U.S. Dollars):</label>
              <div class="col-md-6">
                <input type="number" step="0.01" class="form-control text-right" [value]="selectedTabDData[7]?.VALUE"
                  (input)="onSectionDInputChange(7, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name and address of person to whom disposition of stock was made:</label>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-4">
                    <label>
                      <input type="radio" name="personOrBusiness_D" value="P"
                        [checked]="selectedTabDData[8]?.VALUE === 'P'" (change)="onSectionDInputChange(8, $event)">
                      Person
                    </label>
                  </div>
                  <div class="col-md-4">
                    <label>
                      <input type="radio" name="personOrBusiness_D" value="B"
                        [checked]="selectedTabDData[8]?.VALUE === 'B'" (change)="onSectionDInputChange(8, $event)">
                      Business
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name Line 1:</label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" required [value]="selectedTabDData[9]?.VALUE"
                  (input)="onSectionDInputChange(9, $event)"
                  [class.is-invalid]="hasValidationError('sectionD_name')">
                @if (hasValidationError('sectionD_name')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_name') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name Line 2 (allowed only if name/address type is Business):</label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" [disabled]="selectedTabDData[8]?.VALUE === 'P'"
                  [value]="selectedTabDData[10]?.VALUE" (input)="onSectionDInputChange(10, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Country:</label>
              <div class="col-md-6">
                <select class="form-control" required [value]="selectedTabDData[11]?.VALUE?.COUNTRY_CODE"
                  (change)="onSectionDCountryChange($event)"
                  [class.is-invalid]="hasValidationError('sectionD_country')">
                  <option value="">Select Country</option>
                  @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE"
                    [selected]="selectedTabDData[11]?.VALUE?.COUNTRY_CODE === country.COUNTRY_CODE">
                    {{country.COUNTRY_CODE}} - {{country.COUNTRY_NAME}}
                  </option>
}
                </select>
                @if (hasValidationError('sectionD_country')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_country') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Address Line 1:</label>
              <div class="col-md-6">
                <input type="text" maxlength="35" class="form-control" required [value]="selectedTabDData[12]?.VALUE"
                  (input)="onSectionDInputChange(12, $event)"
                  [class.is-invalid]="hasValidationError('sectionD_address1')">
                @if (hasValidationError('sectionD_address1')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_address1') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Address Line 2:</label>
              <div class="col-md-6">
                <input type="text" maxlength="35" class="form-control" [value]="selectedTabDData[13]?.VALUE"
                  (input)="onSectionDInputChange(13, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">City:</label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" required [value]="selectedTabDData[14]?.VALUE"
                  (input)="onSectionDInputChange(14, $event)"
                  [class.is-invalid]="hasValidationError('sectionD_city')">
                @if (hasValidationError('sectionD_city')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_city') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">State:</label>
              <div class="col-md-6">
                @if (selectedTabDData[11]?.VALUE?.COUNTRY_CODE === 'US') {
<select class="form-control"
                  [value]="selectedTabDData[15]?.VALUE?.code || selectedTabDData[15]?.VALUE" (change)="onSectionDInputChange(15, $event)" required
                  [class.is-invalid]="hasValidationError('sectionD_state')">
                  <option value="">Select State</option>
                  @for (state of states; track $index) {
<option [value]="state.code"
                    [selected]="(selectedTabDData[15]?.VALUE?.code || selectedTabDData[15]?.VALUE) === state.code">
                    {{state.code}} - {{state.name}}
                  </option>
}
                </select>
}
                @if (selectedTabDData[11]?.VALUE?.COUNTRY_CODE !== 'US') {
<input type="text" maxlength="50" class="form-control"
                  [value]="selectedTabDData[15]?.VALUE"
                  (input)="onSectionDInputChange(15, $event)"
                  [class.is-invalid]="hasValidationError('sectionD_state')">
}
                @if (hasValidationError('sectionD_state')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_state') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Zip/Postal Code:</label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" required [value]="selectedTabDData[16]?.VALUE"
                  (input)="onSectionDInputChange(16, $event)"
                  [class.is-invalid]="hasValidationError('sectionD_zip')">
                @if (hasValidationError('sectionD_zip')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionD_zip') }}
                </div>
}
              </div>
            </div>

          </div>
        </div>
}

        <!-- Section E - Reorganization Information (Tab 3) -->
        @if (activeTab === 3) {
<div class="tab-pane active" style="max-height: calc(90vh - 200px);">
          <div>
            <div class="text-center">
              <h3><b>Form 5471 Schedule O: Section E - Reorganization Information</b></h3>
            </div>

            <div class="row form-group">
              <div class="col-md-12">
                <input type="checkbox" [checked]="selectedTabEData[0]?.VALUE === 'true'"
                  (change)="onSectionECheckboxChange(0, $event)">
                <b> Click here for Corporation Name Change</b>
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name and address of transferor:</label>
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-4">
                    <label>
                      <input type="radio" name="personOrBusiness_E" value="P"
                        [checked]="selectedTabEData[1]?.VALUE === 'P'"
                        [disabled]="selectedTabEData[0]?.VALUE === 'true'" (change)="onSectionEInputChange(1, $event)">
                      Person
                    </label>
                  </div>
                  <div class="col-md-4">
                    <label>
                      <input type="radio" name="personOrBusiness_E" value="B"
                        [checked]="selectedTabEData[1]?.VALUE === 'B'"
                        [disabled]="selectedTabEData[0]?.VALUE === 'true'" (change)="onSectionEInputChange(1, $event)">
                      Business
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name Line 1:</label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" required [value]="selectedTabEData[2]?.VALUE"
                  (input)="onSectionEInputChange(2, $event)"
                  [class.is-invalid]="hasValidationError('sectionE_name')">
                @if (hasValidationError('sectionE_name')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionE_name') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Name Line 2 (allowed only if name/address type is Business):</label>
              <div class="col-md-6">
                <input type="text" maxlength="75" class="form-control" [disabled]="selectedTabEData[1]?.VALUE === 'P'"
                  [value]="selectedTabEData[3]?.VALUE" (input)="onSectionEInputChange(3, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Country:</label>
              <div class="col-md-6">
                <select class="form-control" required [disabled]="selectedTabEData[0]?.VALUE === 'true'"
                  [value]="selectedTabEData[4]?.VALUE?.COUNTRY_CODE" (change)="onSectionECountryChange($event)"
                  [class.is-invalid]="hasValidationError('sectionE_country')">
                  <option value="">Select Country</option>
                  @for (country of countries; track $index) {
<option [value]="country.COUNTRY_CODE"
                    [selected]="selectedTabEData[4]?.VALUE?.COUNTRY_CODE === country.COUNTRY_CODE">
                    {{country.COUNTRY_CODE}} - {{country.COUNTRY_NAME}}
                  </option>
}
                </select>
                @if (hasValidationError('sectionE_country')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionE_country') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Address Line 1:</label>
              <div class="col-md-6">
                <input type="text" maxlength="35" class="form-control" required
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[5]?.VALUE"
                  (input)="onSectionEInputChange(5, $event)"
                  [class.is-invalid]="hasValidationError('sectionE_address1')">
                @if (hasValidationError('sectionE_address1')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionE_address1') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Address Line 2:</label>
              <div class="col-md-6">
                <input type="text" maxlength="35" class="form-control"
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[6]?.VALUE"
                  (input)="onSectionEInputChange(6, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">City:</label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" required
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[7]?.VALUE"
                  (input)="onSectionEInputChange(7, $event)"
                  [class.is-invalid]="hasValidationError('sectionE_city')">
                @if (hasValidationError('sectionE_city')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionE_city') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">State:</label>
              <div class="col-md-6">
                @if (selectedTabEData[4]?.VALUE?.COUNTRY_CODE === 'US') {
<select class="form-control"
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'"
                  [value]="selectedTabEData[8]?.VALUE?.code || selectedTabEData[8]?.VALUE"
                  (change)="onSectionEInputChange(8, $event)" required
                  [class.is-invalid]="hasValidationError('sectionE_state')">
                  <option value="">Select State</option>
                  @for (state of states; track $index) {
<option [value]="state.code"
                    [selected]="(selectedTabEData[8]?.VALUE?.code || selectedTabEData[8]?.VALUE) === state.code">
                    {{state.code}} - {{state.name}}
                  </option>
}
                </select>
}
                @if (selectedTabEData[4]?.VALUE?.COUNTRY_CODE !== 'US') {
<input type="text" maxlength="50" class="form-control"
                 
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[8]?.VALUE"
                  (input)="onSectionEInputChange(8, $event)"
                  [class.is-invalid]="hasValidationError('sectionE_state')">
}
                @if (hasValidationError('sectionE_state')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionE_state') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Zip/Postal Code:</label>
              <div class="col-md-6">
                <input type="text" maxlength="50" class="form-control" required
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[9]?.VALUE"
                  (input)="onSectionEInputChange(9, $event)"
                  [class.is-invalid]="hasValidationError('sectionE_zip')">
                @if (hasValidationError('sectionE_zip')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionE_zip') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Identifying number (if any):</label>
              <div class="col-md-6">
                <div class="row align-items-center">
                  <div class="col-md-4">
                    <input class="form-control" maxlength="10" type="text"
                      [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[10]?.DISVALUE"
                      (input)="onSectionEIdentifyingNumberChange($event)">
                  </div>
                  <div class="col-md-4">
                    <input type="radio" name="identify_E" value="APPLD FOR"
                      [disabled]="selectedTabEData[0]?.VALUE === 'true'"
                      [checked]="selectedTabEData[16]?.VALUE === 'APPLD FOR'"
                      (change)="onSectionEIdentifyingRadioChange('APPLD FOR')"> Applied For
                  </div>
                  <div class="col-md-4">
                    <input type="radio" name="identify_E" value="FOREIGNUS"
                      [disabled]="selectedTabEData[0]?.VALUE === 'true'"
                      [checked]="selectedTabEData[16]?.VALUE === 'FOREIGNUS'"
                      (change)="onSectionEIdentifyingRadioChange('FOREIGNUS')"> Not Applicable
                  </div>
                </div>
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Date of Transfer:</label>
              <div class="col-md-6">
                <input type="date" class="form-control" [value]="selectedTabEData[11]?.VALUE"
                  (input)="onSectionEInputChange(11, $event)"
                  [class.is-invalid]="hasValidationError('sectionE_date')">
                @if (hasValidationError('sectionE_date')) {
<div class="invalid-feedback">
                  {{ getValidationError('sectionE_date') }}
                </div>
}
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Description of assets:</label>
              <div class="col-md-6">
                <input type="text" maxlength="40" class="form-control"
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[12]?.VALUE"
                  (input)="onSectionEInputChange(12, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Fair market value (in U.S. Dollars):</label>
              <div class="col-md-6">
                <input type="number" step="0.01" class="form-control text-right"
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[13]?.VALUE"
                  (input)="onSectionEInputChange(13, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Adjusted basis (if transferor was U.S. person, in U.S. Dollars):</label>
              <div class="col-md-6">
                <input type="number" step="0.01" class="form-control text-right"
                  [disabled]="selectedTabEData[0]?.VALUE === 'true' || selectedTabEData[4]?.VALUE?.COUNTRY_CODE !== 'US'"
                  [value]="selectedTabEData[14]?.VALUE" (input)="onSectionEInputChange(14, $event)">
              </div>
            </div>

            <div class="row form-group">
              <label class="col-md-6">Description of assets transferred by, or notes or securities issued by, foreign
                corporation:</label>
              <div class="col-md-6">
                <input type="text" maxlength="40" class="form-control"
                  [disabled]="selectedTabEData[0]?.VALUE === 'true'" [value]="selectedTabEData[15]?.VALUE"
                  (input)="onSectionEInputChange(15, $event)">
              </div>
            </div>
          </div>
        </div>
}

      </div>
    </div>
}
  </div>
}

  <!-- STANDARD Footer (V7) -->
  <div class="modal-footer" [hidden]="minimise">
    @if (currentTabName != 'Subsidiary') {
<button class="save-button" type="button" [disabled]="isSaveClicked"
      (click)="save()">
      @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
    </button>
}
    @if (currentTabName != 'Subsidiary') {
<button class="reset-button" type="button" (click)="reset()">Reset</button>
}
    <button class="cancel-button" type="button" (click)="cancel()">Cancel</button>
  </div>

</div>